__turbopack_context__.v({
  "className": "geistmono_cfbefb1d-module__tUxLBG__className",
  "variable": "geistmono_cfbefb1d-module__tUxLBG__variable",
});
